













































import { Vue, Component, Prop } from 'vue-property-decorator';
import WlAvatar from '@/components/Commons/WlAvatar.vue';
import CommentAction from './CommentAction.vue';
import moment from 'moment';
import ReportFlagComment from './ReportFlagComment.vue';
import { vxm } from '@/store.vuex';
@Component({
  components: {
    WlAvatar,
    CommentAction,
    ReportFlagComment,
  },
})
export default class Comment extends Vue {
  private showEditComment: boolean = false;
  private editText: string = '';
  $wlToastr: any;
  @Prop({}) details;
  @Prop({}) postId;
  @Prop() isPostDetailsPage;
  get fullName() {
    return `${this.details.candidateInfo.firstName} ${
      this.details.candidateInfo.lastName
    }`;
  }
  get postDate() {
    const createdDate = moment(this.details.createdDTTM);
    return `${createdDate.format('DD')}th ${createdDate.format(
      'MMM',
    )} at ${createdDate.format('hh:mm a')}`;
  }
  editComment() {
    this.showEditComment = true;
    this.editText = this.details.commentText;
  }
  async updateComment() {
    await vxm.forum.updateComment({
      postId: this.postId,
      commentId: this.details.commentId,
      commentText: this.editText,
    });
    this.$wlToastr('success', 'Comment has been updated');
    this.showEditComment = false;
  }
}
